interface AudioFiles {
  intro_envelope_one_easy: string;
  intro_envelope_one_medium: string;
  intro_envelope_one_hard: string;
  how_to_play: string;
  intro_envelope_two?: string;
  stages_complete: string;
}

interface BatchConfig {
  displayName: string;
  stagesFile: string;
  helpDataFile: string; // Help data JSON file, defaults to DEFAULTS.helpDataFile
  policeServerEpisode: string; // e.g., "004_batch2", defaults to DEFAULTS.policeServerEpisode
  policeServerUsername: string; // Username for police server access, defaults to DEFAULTS.policeServerUsername
  audios: Partial<AudioFiles>; // Override specific audio files
  hasMultipleEnvelopes?: boolean; // Indicates if batch has envelope 2
}

interface AppConfigType {
  SHOW_BATCH_SELECTION: boolean;
  DEFAULT_BATCH: string;
  PRESELECTED_BATCH: string;
  DEFAULTS: {
    stagesFile: string;
    helpDataFile: string;
    policeServerEpisode: string;
    policeServerUsername: string;
    audios: AudioFiles;
  };
  BATCHES: {
    [key: string]: BatchConfig;
  };
}

export const AppConfig: AppConfigType = {
  SHOW_BATCH_SELECTION: true, // set to true when multiple batches exist
  DEFAULT_BATCH: "default",
  PRESELECTED_BATCH: "default",
  DEFAULTS: {
    stagesFile: "stages_ks03_v1.json",
    helpDataFile: "help-data_v1.json",
    policeServerEpisode: "003",
    policeServerUsername: "HECKLMEIER",
    audios: {
      intro_envelope_one_easy: "/audios/intro_v1.mp3",
      intro_envelope_one_medium: "/audios/intro_v1.mp3",
      intro_envelope_one_hard: "/audios/intro_v1.mp3",
      how_to_play: "/audios/how_to_play_v1",
      stages_complete: "/audios/stages_complete_v1.mp3",
    },
  },
  BATCHES: {
    default: {
      displayName: "Auflage 1 (keine Umschläge)",
      stagesFile: "stages_ks03_v1.json",
      helpDataFile: "ks03_help-data_v1.json",
      policeServerEpisode: "003",
      policeServerUsername: "HECKLMEIER",
      hasMultipleEnvelopes: false,
      audios: {
        intro_envelope_one_easy: "/audios/intro_envelope_one.mp3",
        intro_envelope_one_medium: "/audios/intro_envelope_one.mp3",
        intro_envelope_one_hard: "/audios/intro_envelope_one.mp3",
        how_to_play: "/audios/how_to_play_v1",
        stages_complete: "/audios/stages_complete_v1.mp3",
      },
    },
    batch2: {
      displayName: "Auflage 2 (zwei Umschläge)",
      stagesFile: "stages_ks03_v2.json",
      helpDataFile: "ks03_help-data_v2.json",
      policeServerEpisode: "003_batch2",
      policeServerUsername: "HECKLMEIER",
      hasMultipleEnvelopes: true,
      audios: {
        intro_envelope_one_easy: "/audios/intro_envelope_one.mp3",
        intro_envelope_one_medium: "/audios/intro_envelope_one.mp3",
        intro_envelope_one_hard: "/audios/intro_envelope_one.mp3",
        how_to_play: "/audios/how_to_play_v2",
        intro_envelope_two: "/audios/intro_envelope_two_v2.mp3",
        stages_complete: "/audios/stages_complete_v2.mp3",
      },
    },
  },
};

